// src/features/home/components/ExperienceCard.tsx

import React from 'react';
import styles from './ExperienceCard.module.scss';

interface ExperienceCardProps {
  startDate: string;
  endDate: string;
  company: string;
  companyUrl?: string;
  role: string;
  description: string[];
  technologies: string[];
}

const ExperienceCard: React.FC<ExperienceCardProps> = ({
  startDate,
  endDate,
  company,
  companyUrl,
  role,
  description,
  technologies,
}) => {
  const cardContent = (
    <>
      <div className={styles.hoverOverlay}></div>
      <header className={styles.dates} aria-label={`${startDate} to ${endDate}`}>
        {startDate} — {endDate}
      </header>
      <div className={styles.details}>
        <h3 className={styles.title}>
          <div>
            <span>
              {role} · {company}
              {companyUrl && (
                <svg
                  className={styles.externalLinkIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5A.75.75 0 0013.25 5h-7.5a.75.75 0 000 1.5h5.69L4.22 13.72a.75.75 0 000 1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </span>
          </div>
        </h3>
        <p className={styles.description}>
          {description.map((item, index) => (
            <span key={index}>
              {item}
              {index < description.length - 1 && <br />}
            </span>
          ))}
        </p>
        <ul className={styles.techList} aria-label="Technologies used">
          {technologies.map((tech, index) => (
            <li key={index} className={styles.techItem}>
              <div className={styles.techBadge}>{tech}</div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );

  return (
    <li className={styles.experienceItem}>
      {companyUrl ? (
        <a
          href={companyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.experienceCard}
          aria-label={`${role} at ${company} (opens in a new tab)`}
        >
          {cardContent}
        </a>
      ) : (
        <div className={styles.experienceCard}>{cardContent}</div>
      )}
    </li>
  );
};

export default ExperienceCard;